import * as React from 'react'
import * as classNames from 'classnames'

const IconArrowRight = (props: { className?: string }) => {
  const classnames = classNames(`icon`, props.className)
  return (
    <svg
      className={classnames}
      fill='#dcdcdc'
      width='7'
      height='12'
      viewBox='0 0 7 12'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path fillRule='evenodd' clipRule='evenodd' d='M0 10.6L4.35135 6L0 1.4L1.32432 0L7 6L1.32432 12L0 10.6Z' />
    </svg>
  )
}

export default IconArrowRight



// WEBPACK FOOTER //
// ./src/components/icons/ui/IconArrowRight.tsx